import React from 'react';
import { useTranslation } from 'react-i18next';
import withCustomComponent from 'ui/components/withCustomComponent';

export const BlogPageZeroCase = withCustomComponent('BlogPageZeroCase')(({
  componentName,
}) => {
  const { t } = useTranslation();
  return (
    <div data-component-name={componentName} className="text-center pt-32">
      <i className="icon-ticket fs-64 text-gray-600"></i>
      <h3 className="mt-12 mb-24">{t('There are no articles to display')}</h3>
    </div>
  );
});
